import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useGetStudioDetails } from '~entities/studios/api/get-studio-details';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import { getWalletLoadPath } from '../lib/wallet-api-path';
import type {
  LoadWalletBalanceResponse,
  LoadWalletBalanceRequest,
} from '../model/types';

export const loadWalletBalanceAPI = async (
  parentId: string,
  data: LoadWalletBalanceRequest,
  isV2 = false,
) => {
  const response = await baseAPI.post<LoadWalletBalanceResponse>(
    getWalletLoadPath(parentId, isV2),
    data,
  );
  return response.data;
};

export const useLoadWalletBalance = (parentId: string) => {
  const queryClient = useQueryClient();
  const { data: studioDetails } = useGetStudioDetails();
  const isV2 = studioDetails?.isV2 === true;

  return useMutation({
    mutationFn: (data: LoadWalletBalanceRequest) =>
      loadWalletBalanceAPI(parentId, data, isV2),
    onSuccess: () => {
      // Invalidate balance query to trigger a refresh
      void queryClient.invalidateQueries({
        queryKey: [KEYS.WALLET_BALANCE, parentId],
      });
      void queryClient.invalidateQueries({
        queryKey: [KEYS.PARENT_WALLET_TRANSACTIONS, parentId],
      });
    },
  });
};
